// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"68590dff","159":"8d501121","420":"d8e16538","644":"a62b72a3","782":"3edd36a6"}[chunkId] + ".chunk.css";
};